// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap'

import 'magnific-popup/dist/jquery.magnific-popup';
import 'scrollpos-styler';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
// import booking from './routes/booking';
import cart from './routes/cart';
// import shop from './routes/shop';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // booking,
  cart,
  // shop,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js